export default "__VITE_ASSET__Dr_6Xc2N__"